@layer tbw-plugins {
  /* Group row layout - uses grid template from parent */
  .group-row {
    display: grid;
    grid-template-columns: var(--tbw-column-template);
    background: var(--tbw-grouping-rows-bg, var(--tbw-color-panel-bg));
    font-weight: 500;
    border-bottom: var(--tbw-row-divider);
    min-height: var(--tbw-row-height);
  }
  .group-row .cell {
    display: flex;
    align-items: center;
    padding: var(--tbw-cell-padding, 0.125rem 0.5rem);
  }
  @media (hover: hover) {
    .group-row:hover {
      background: var(--tbw-grouping-rows-bg-hover, var(--tbw-color-row-hover));
    }
  }
  .group-toggle {
    cursor: pointer;
    user-select: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--tbw-toggle-size, 1.25rem);
    height: var(--tbw-toggle-size, 1.25rem);
    margin-right: 0.25rem;
    background: none;
    border: 0;
    font: inherit;
  }
  .group-toggle:hover {
    background: var(--tbw-grouping-rows-toggle-hover, var(--tbw-color-row-hover));
    border-radius: var(--tbw-border-radius, 0.125rem);
  }

  /* SC 2.5.8: grow the target, not the box, so the group row keeps its height. */
  .group-toggle {
    position: relative;

    &::after {
      content: '';
      position: absolute;
      inset-block-start: 50%;
      inset-inline-start: 50%;
      translate: -50% -50%;
      inline-size: var(--tbw-touch-target-min, 24px);
      block-size: var(--tbw-touch-target-min, 24px);
    }
  }

  @media (pointer: coarse) {
    .group-toggle {
      min-width: var(--tbw-touch-target-min, 24px);
      min-height: var(--tbw-touch-target-min, 24px);
    }
  }
  .group-label {
    display: inline-flex;
    align-items: center;
    gap: var(--tbw-panel-gap, var(--tbw-spacing-md, 0.5rem));
  }
  .group-count {
    color: var(--tbw-grouping-rows-count-color, var(--tbw-color-fg-muted));
    font-size: var(--tbw-font-size-xs, 0.85em);
    font-weight: normal;
  }

  /* Aggregates container (for full-width mode) */
  .group-aggregates {
    display: inline-flex;
    align-items: center;
    gap: var(--tbw-spacing-lg, 1rem);
    margin-left: var(--tbw-spacing-lg, 1rem);
    font-weight: normal;
    font-size: var(--tbw-font-size-sm, 0.875em);
    color: var(--tbw-grouping-rows-aggregate-color, var(--tbw-color-fg-muted));
  }

  .group-aggregate {
    white-space: nowrap;
  }

  /* Depth-based indentation using CSS custom property */
  .group-row {
    padding-left: calc(var(--tbw-group-depth, 0) * var(--tbw-group-indent-width, 1.25em));
  }

  /* Slide animation for child rows appearing */
  .data-grid-row.tbw-group-slide-in {
    animation: tbw-group-slide-in var(--tbw-animation-duration, 200ms) var(--tbw-animation-easing, ease-out) forwards;
  }

  @keyframes tbw-group-slide-in {
    from {
      opacity: 0;
      transform: translateX(-8px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  /* Fade animation for child rows appearing */
  .data-grid-row.tbw-group-fade-in {
    animation: tbw-group-fade-in var(--tbw-animation-duration, 200ms) var(--tbw-animation-easing, ease-out) forwards;
  }

  @keyframes tbw-group-fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
} /* End @layer tbw-plugins */
